var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-owner"},[_c('a',{attrs:{"href":_vm.data.html_url,"target":"_blank"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.data.avatar_url}})]),_vm._v(" "),_c('div',{staticClass:"infos"},[_c('div',{staticClass:"login"},[_vm._v(_vm._s(_vm.data.login))]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Owner")])])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83cd9e3a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ModuleOwner.vue
// module id = 533
// module chunks = 0